import React from 'react';

import { useI18n } from 'i18n/I18nContext';

const Video = () => {
  const { t } = useI18n();

  return (
    <section className="gb-home-section gb-home-video" aria-labelledby="gb-video-heading">
      <div className="container gb-home-section__inner">
        <header className="gb-home-section__intro gb-home-section__intro--center">
          <h2 id="gb-video-heading" className="gb-home-section__title">
            {t('home.videoHeading')}
          </h2>
          <p className="gb-home-section__lede m-0">{t('home.videoLede')}</p>
        </header>

        <div className="gb-home-video__frame">
          <iframe
            title={t('home.videoTitle')}
            src="https://player.vimeo.com/video/249669301?color=c9ff23&byline=0&portrait=0"
            frameBorder={0}
            allow="fullscreen; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </section>
  );
};

export default Video;



// WEBPACK FOOTER //
// ./src/components/Video.tsx